<template>
  <div>
    <task-dialog :title="$t('lang.firmware.configuration')" ref="Dialog" :packlist="packlist" @getupgradelist="showconlist"></task-dialog>
    <el-button type="primary" size="mini" class="elinput" @click="$refs.Dialog.showDialog()" v-if="Permission.indexOf(109)!=-1">{{$t('lang.firmware.hFirstTask')}}</el-button>
    <!--xlsx表格导出-->
    <xlsx style="margin-bottom: 0.2rem;margin-top: 0.2rem" v-if="Permission.indexOf(124)!=-1"></xlsx>
    <el-select v-model="ListStatusValue" size="mini"
    @change="GetStatusList">
    <el-option
      v-for="item in ListStatus"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
    </el-select>
    <!-- <p class="tabletitle"></p> -->
<!--    表格组件-->
    <TableComponent
            :RowKey="'tId'"
            :data="data"
            :Expand="true"
            :seek="seek"
            :slot="true"
            :DeteleTitle="$t('lang.firmware.CompositeTask')"
            :Columns="Columns"
            :ColuumnsButton="ColuumnsButton"
            :Expands="Expands"
            :ExpandKey="'subTasks'"
            :ExpandsButton="ExpandsButton"
            :ExpandId="'stTid'"
            :DeleteTitle="$t('lang.firmware.CompositeTask')"
            @GetFirmwareStatus="GetFirmwareStatus"
            @GetFirmwareChildStatus="GetFirmwareChildStatus"
            @GetFirmwareSn="GetFirmwareSn"
            @sortChange="sortChange"
            @delLevelUp="delLevelUp"
            @delSonLevelUp="delSonLevelUp"
            @GetSubtasks="GetSubtasks"
            @GetCfName="GetCfName">
            <span 
              slot="ChildSlot" 
              slot-scope="scope" 
              style="color:#409eff;font-size:15px;">
              {{scope.scope.$index+1}}
            </span>
            <el-progress 
              slot="slot" 
              slot-scope="scope" 
              :percentage="~~(scope.scope.row.progress*100)" 
              :color="customColorMethod"/>
            <span 
              slot="childCustomColumn" 
              slot-scope="scope" 
              style="font-size:15px;">
              <!-- {{scope.scope.row}} -->
              {{scope.scope.row.device.deviceSn}}&nbsp;({{scope.scope.row.device.deviceName ? scope.scope.row.device.deviceName : 'N/A'}})
            </span>
    </TableComponent>
    <!--分页组件-->
    <pagination
      :total="total"
      :offset="offset"
      :limit="limit"
      @SizeChanges="SizeChanges"
      @CurrentChanges="CurrentChanges"
    ></pagination>
  </div>
</template>

<script>
import pagination from "@/components/pagination";
import xlsx from "@/components/xlsx";
import TaskDialog from "../components/dialog/FirmwareDialog";
import { getPermission } from '../../../cookie/cookie';
import { listConfig,listConfigurationFile,queryKeyword,delLevelUp,delSonLevelUp,GetListConfig } from '@/api/firmware'
import { setInterval, clearInterval } from 'timers';
import { PublicComponent } from '../../../mixins/common'
import TableComponent from '@/components/TableComponent/index'
import { ColuumnsButton,Columns,Expands,ExpandsButton } from './TableConfig'
export default {
  mixins:[PublicComponent],
  data() {
    return {
      Columns:Columns,
      ColuumnsButton:ColuumnsButton,
      Expands:Expands,
      ExpandsButton:ExpandsButton,
      Permission:[],
      data: [],
      //搜索
      seek: {
        tName: "",
        tDescription: "",
        stProgress: "",
        cfName: "",
        tUpdate: ""
      },
      //排序
      sort: {
        tName: null,
        tDescription: null,
        stProgress: null,
        cfName: null,
        tUpdate: null
      },
      value: "",
      input: "",
      packlist: [],
      //定时器函数
      Refreshs:null,
      //状态下拉框
      ListStatus:[
        {label:this.$t('lang.firmware.MissionAccomplished'),value:1},
        {label:this.$t('lang.firmware.Ongoing'),value:0}
      ],
      //状态下拉框选中值
      ListStatusValue:1,
      //获取子任务的tid
      tid:undefined
    };
  },
  components: {
    pagination,
    xlsx,
    TaskDialog,
    TableComponent
  },
  methods: {
    //查询排序
    queryKeyword(){
      queryKeyword([this.seek.tName,this.seek.tDescription,this.seek.stProgress,
        this.seek.cfName,this.seek.tUpdate],this.offset,this.limit,this.sort,this.ListStatusValue,this.tid)
      .then((res)=>{
      this.data=res.data.data.list
      this.total=res.data.data.total
      this.data.unshift({})
      })
    },
    //表格排序
    sortChange(column) {
      //每次点击清空一次排序的赋值
      this.sort = {
        tName: null,
        tDescription: null,
        stProgress: null,
        cfName: null,
        tUpdate: null
      };
      // 未找到索引等信息，采用id值判断 //获取当前#id值，截取最后一个字符串转换成数字，再减1获取到当前索引
      let label = null;
      if (column != null) {
        label = column.label;
      } else {
        label = null;
      }
      let sortlist = null;
      if (column != null) {
        if (column.order == "ascending") {
          sortlist = 0;
        } else if (column.order == "descending") {
          sortlist = 1;
        } else {
          sortlist = null;
        }
      }
      if (label == this.$t('lang.firmware.multitasking')) {
        this.sort.tName = sortlist;
      } else if (label == this.$t('lang.firmware.VI_Task')) {
        this.sort.tDescription = sortlist;
      } else if (label == this.$t('lang.firmware.AsyncOperationStatus')) {
        this.sort.stProgress = sortlist;
      } else if (label == this.$t('lang.firmware.createFile')) {
        this.sort.cfName = sortlist;
      } else if (label == this.$t('lang.firmware.timerfunction')) {
        this.sort.tUpdate = sortlist;
      }
    },
    //删除任务
    delLevelUp(row){
      delLevelUp(row.tId)
      .then((res)=>{
        if(res.data.code==0){
          this.$message({
          showClose: true,
          message: this.$t('lang.firmware.TestDelete'),
          type: 'success'
        });
        this.queryKeyword()
        }
        else{
           this.$message({
          showClose: true,
          message: this.$t('lang.firmware.intbdb_delete'),
          type: 'error'
        });
        }
      })
    },
    //删除子任务
    delSonLevelUp(row){
      delSonLevelUp(row.stId)
      .then((res)=>{
        if(res.data.code==0){
          this.$message({
          showClose: true,
          message: this.$t('lang.firmware.TestDelete'),
          type: 'success'
        });
        this.queryKeyword()
        }
        else {
          this.$message({
          showClose: true,
          message: this.$t('lang.firmware.intbdb_delete'),
          type: 'warning'
        });
        }
      })
    },
    //隐藏弹出层
    showconlist(){
      this.queryKeyword()
    },
    //获取当前任务状态
    GetFirmwareStatus(row){
        switch (row) {
          case '0':
            return {status:'success',TagName:'配置完成'}
          case '1':
            return {status:'',TagName:this.$t('lang.upgrade.define')}
          case '2':
            return {status:'success',TagName:this.$t('lang.upgrade.DownloadEventNotifier')}
          case '3':
            return {status:'',TagName:this.$t('lang.upgrade.upgrading')}
          case '4':
            return {status:'success',TagName:this.$t('lang.upgrade.upgrade_drush_command')}
          case '5':
            return  {status:'warning',TagName:this.$t('lang.upgrade.username_last_used')}
          case '6':
            return  {status:'warning',TagName:this.$t('lang.upgrade.tempfile')}
          case '7':
            return  {status:'warning',TagName:this.$t('lang.upgrade.Translators')}
          case '8':
            return  {status:'warning',TagName:this.$t('lang.upgrade.zxid_add_name_field')}
          case '9':
            return  {status:'warning',TagName:this.$t('lang.upgrade.DOWNLOADER_CLIENT_TLS_METHOD')}
          case '11':
            return  {status:'warning',TagName:this.$t('lang.upgrade.BAG_FILTER_EQUIPMENT')}
          case '13':
            return  {status:'warning',TagName:'版本不支持，请升级设备到最新版本'}
          case 'A':
            return  {status:'warning',TagName:this.$t('lang.upgrade.boolCheckPingURI')}
          case 'B':
            return  {status:'warning',TagName:this.$t('lang.upgrade.upgrade_alter_tables')}
          case 'C':
            return  {status:'warning',TagName:this.$t('lang.upgrade.keymaster_error_t')}
          case 'D':
            return  {status:'success',TagName:this.$t('lang.upgrade.commands')}
          case 'E':
            return  {status:'warning',TagName:this.$t('lang.upgrade.keymaster_error_t')}
          case 'F':
            return  {status:'success',TagName:this.$t('lang.upgrade.connection')}
          case 'G':
            return  {status:'warning',TagName:this.$t('lang.upgrade.handle_remote_sigint')}
          default:return  {status:'',TagName:'未知错误'}
        }
    },
    //获取当前子任务任务状态
    GetFirmwareChildStatus(row){
      switch (row) {
        case '0':return {status:'success',TagName:'配置完成'}
        case '1':return {status:'',TagName:this.$t('lang.firmware.define')}
        case '2':return {status:'success',TagName:this.$t('lang.firmware.DownloadEventNotifier')}
        case '3':return {status:'',TagName:this.$t('lang.firmware.upgrading')}
        case '4':return {status:'success',TagName:this.$t('lang.firmware.upgrade_drush_command')}
        case '5':return {status:'success',TagName:this.$t('lang.firmware.username_last_used')}
        case '6':return {status:'warning',TagName:this.$t('lang.firmware.tempfile')}
        case '7':return {status:'warning',TagName:this.$t('lang.firmware.Translators')}
        case '8':return {status:'warning',TagName:this.$t('lang.firmware.zxid_add_name_field')}
        case '9':return {status:'warning',TagName:this.$t('lang.firmware.DOWNLOADER_CLIENT_TLS_METHOD')}
        case 'A':return {status:'warning',TagName:this.$t('lang.firmware.boolCheckPingURI')}
        case 'B':return {status:'warning',TagName:this.$t('lang.firmware.upgrade_alter_tables')}
        case 'C':return {status:'warning',TagName:this.$t('lang.firmware.keymaster_error_t')}
        case 'D':return {status:'success',TagName:this.$t('lang.firmware.commands')}
        case 'E':return {status:'warning',TagName:this.$t('lang.firmware.keymaster_error_t')}
        case 'F':return {status:'success',TagName:this.$t('lang.firmware.connection')}
        case 'G':return {status:'warning',TagName:this.$t('lang.firmware.handle_remote_sigint')}
        default:return {status:'',TagName:'异常状态'}
      }
    },
    //获取子任务序列号
    GetFirmwareSn(row){
      return row.device.deviceSn
    },
    //获取当前点击的任务Tid
    GetSubtasks(tid){
      this.tid=tid
      //当前选中的是正在进行的任务
      if(this.ListStatusValue==0){
        this.queryKeyword()
      }else {
        //当前选中完成任务
      listConfig(this.offset,this.limit,this.ListStatusValue)
      .then((res)=>{
      this.data=res.data.data.list
      this.total=res.data.data.total
      this.data.unshift({})
      // 获取当前点击的任务子任务列表
      GetListConfig(tid)
      .then((res)=>{
        this.data.forEach((element,index) => {
          if(element.tId==tid){
            this.$set(this.data[index],'subTasks',res.data.queryResult)
          }
        });
      })
      })
      }
    },
    //根据选中的任务类型(正在进行，完成任务)获取子任务
    GetStatusList(){
      clearInterval(this.Refreshs)
      this.Refreshs=null
      if(this.ListStatusValue==0){
        //查询一次最新的正在进行任务
        this.queryKeyword()
        //获取当前任务列表
        this.Refreshs=setInterval(() => {
        this.queryKeyword()
        }, 5000);
      }else {
        //查询一次最新的正在完成任务
        this.queryKeyword()
        //清除定时器
        clearInterval(this.Refreshs)
        this.Refreshs=null
      }
    },
    //进度条颜色
      customColorMethod(percentage) {
        if (percentage < 30) {
          return '#909399';
        } else if (percentage < 70) {
          return '#e6a23c';
        } else {
          return '#67c23a';
        }
      },
      //获取批量配置文件名
      GetCfName(row){
        return row.configurationFile.cfName
      }
  },
  
  mounted(){
    //从cookie里获取权限
    this.Permission=getPermission()
    listConfig(this.offset,this.limit,this.ListStatusValue)
    .then((res)=>{
      this.data=res.data.data.list
      this.total=res.data.data.total
      this.data.unshift({})
    })
    //获取文件列表传入子组件
    listConfigurationFile()
    .then((res)=>{
      this.packlist=res.data.data.list
    })
  },
  beforeDestroy() {
    //页面销毁前(路由跳转前删除定时器)
    clearInterval(this.Refreshs)
    this.Refreshs=null
  }
};
</script>

<style scoped>
.elinput {
  margin: 0.2rem 0.2rem 0.2rem 0rem;
}
.select {
  width: 3rem;
  margin: 0.2rem;
}

.rightcons {
  float: right;
}

.rightinput {
  display: inline-block;
  width: 3rem;
  margin: 0.2rem;
}

.concen {
  text-align: center;
}

.tabletitle {
  width: 100%;
  height: 0.8rem;
  font-size: 0.25rem;
  line-height: 0.8rem;
  background-color: #4284da;
  color: #ffffff;
  text-indent: 0.5rem;
}
.spanov {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.25rem;
}
</style>
